export function handleWindowPrint(ele, fileName, style, vm) {
  console.log("***********************");
  console.log(fileName);
  var oIframe = document.createElement("iframe");
  var oScript = document.createElement("script");

  document.body.appendChild(oIframe);

  var titleText = document.head.getElementsByTagName("title")[0].innerText;
  document.head.getElementsByTagName("title")[0].innerText = `${fileName}`;

  oIframe.contentDocument.head.innerHTML = `<meta charset="utf-8">
                                            <title>${fileName}</title>
                                            <meta name="format-detection" content="telephone=no">
                                            <meta http-equiv="X-UA-Compatible" content="IE=edge,chrome=1">
                                            <meta name="viewport" content="width=device-width,initial-scale=1.0">
                                            <style>
                                            ${style}
                                            </style>`;

  // oIframe.contentWindow.document.body.innerHTML = document.querySelector(ele).outerHTML;
  oIframe.contentDocument.body.innerHTML = document.querySelector(
    ele
  ).outerHTML;

  oScript.innerHTML = "window.print();";
  oIframe.contentDocument.body.appendChild(oScript);
  //通过定时器来延迟删除oIframe元素，防止oIframe还未渲染完成就被删除，导致打印按钮无反应
  setTimeout(function () {
    document.body.removeChild(oIframe);
  }, 200);
  document.head.getElementsByTagName("title")[0].innerText = titleText;
}